import { connect } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import actions from './actions';
import AppInfo from './components/AppInfo/AppInfo';
import getBuildInfo from './modules/getBuildInfo';
import getDeployInfo from './modules/getDeployInfo';
import React, { Component } from 'react';
import Routes from './Routes';

import './App.scss';

class App extends Component {
    // Using the newer react-helmet-async library instead of the
    // deprecated react-helmet library because it fixes a known
    // memory leak issue the react-helmet library had.
    //
    // The <Helmet> tag should be wrapped by a <HelmetProvider>.
    // The <Helmet> tag down below, allows you to place html into the <head>
    // of the page.
    //
    // The preconnect keyword for the rel attribute of the <link> element is
    // a hint to browsers that the user is likely to need resources from the
    // target resource's origin, and therefore the browser can likely improve
    // the user experience by preemptively initiating a connection to that origin.
    // Preconnecting speeds up future loads from a given origin by preemptively
    // performing part or all of the handshake (DNS+TCP for HTTP, and
    // DNS+TCP+TLS for HTTPS origins).  Specify a separate <link> for each
    // subdomain (https://<subdomain>.<domain>.com)

    componentDidMount() {
        sessionStorage.setItem('pathname', window.location.pathname);
    }

    async componentWillMount() {
        try {
            const isRunningLocally = process.env.NODE_ENV === 'development';

            if (!isRunningLocally) {
                const deploy = await getDeployInfo();
                const build = await getBuildInfo();

                this.props.setAppInfo({
                    build: { ...build },
                    deploy: { ...deploy }
                });
            } else {
                this.props.setAppInfo({
                    build: {},
                    deploy: { env: 'localhost' }
                });
            }
        } catch (err) {
            console.error(err);
        }
    }

    render() {
        return (
            <HelmetProvider>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Safeco</title>
                    <link
                        rel='preconnect'
                        href='http://cdn.heapanalytics.com'
                        crossOrigin='crossorigin'
                    />
                    <link
                        rel='preconnect'
                        href='http://cdnssl.clicktale.net'
                        crossOrigin='crossorigin'
                    />
                    <script src='contentsquare.js' async />
                    <script src='heap.js' async />
                </Helmet>
                <AppInfo />
                <Routes
                    home={sessionStorage.getItem('pathname')}
                    customer={this.props.customer}
                    search={window.location.search}
                />
            </HelmetProvider>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setAppInfo: data => dispatch(actions.app.setInfo(data))
    };
}

function mapStoreToProps(store) {
    return {
        app: store.app,
        customer: store.customer
    };
}

export default connect(
    mapStoreToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js